import "./App.css";
import "@fontsource/aileron";
import "@fontsource/roboto";
import "@fontsource/rubik";

import React from "react";

import BarGraphic from "./components/BarGraphic";
import FilterControl from "./components/FilterControl";
import Header from "./components/Header";
import HeatMapGraphic from "./components/HeatMapGraphic";
import LinearGraphic from "./components/LinearGraphic";
import MapGraphic from "./components/MapGraphic";
import TextGraphic from "./components/TextGraphic";
import ContextProvider from "./contexts";

function App() {
  return (
    <ContextProvider>
      <div className="container">
        <div className="wrapper">
          <Header />
        </div>
        <div className="wrapper">
          <FilterControl />
        </div>
        <div className="wrapper">
          <TextGraphic />
        </div>
        <div className="wrapper">
          <div className="parent">
            <BarGraphic />
            <div className="divider"></div>
            <LinearGraphic />
          </div>
        </div>
        <div className="wrapper">
          <HeatMapGraphic />
        </div>
        <div className="wrapper">
          <div>
            <MapGraphic />
          </div>
        </div>
        <div className="footerDivider"></div>
      </div>
    </ContextProvider>
  );
}

export default App;
